import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import debounce from "lodash/debounce";

import OnScreen from "components/OnScreen";
import FancyImage from "components/FancyImage";
import Video from "components/Video";
import css from "./Media.module.scss";

export class Media extends React.Component {
    static propTypes = {
        video: PropTypes.array,
        image: PropTypes.string,
        imageMobile: PropTypes.string,
        alt: PropTypes.string,
        onScreen: PropTypes.bool,
        style: PropTypes.object,
        className: PropTypes.string,
        theme: PropTypes.string,
        gradient: PropTypes.string,
        hasGradient:PropTypes.bool
    };

    static themes = FancyImage.themes;
    static gradients = FancyImage.gradients;

    static defaultProps = {
        onScreen: true,
        hasGradient: true
    };

    state = {
        isMobile: false
    };

    _debouncedUpdatePredicate = debounce(() => {
        this.setState({
            isMobile: window && window.innerWidth < 960
        });
    }, 300);

    componentDidMount() {
        this._debouncedUpdatePredicate();

        window.addEventListener("resize", this._debouncedUpdatePredicate);
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this._debouncedUpdatePredicate);
    };

    render() {
        const {
            onScreen,
            video,
            style,
            alt,
            image,
            imageMobile,
            theme,
            gradient,
            className,
            hasGradient
        } = this.props;
        const { isMobile } = this.state;
        const imageProps = {
            alt: alt || "",
            image,
            imageMobile,
            theme,
            isMobile,
            gradient
        };
        return (
            <div
                style={style}
                className={cn(css.media, {
                    [css.visible]: onScreen,
                    [className]: className
                })}
            >
                {onScreen &&
                    (video && video.length > 0 ? (
                        <Video
                            videos={video}
                            isMobile={isMobile}
                            fallbackImage={imageProps}
                            isFixed={theme === FancyImage.themes.fixed}
                            hasGradient={hasGradient}
                        />
                    ) : 
                        image && <FancyImage {...imageProps} />
                    )}
            </div>
        );
    }
}

export default OnScreen(Media);



// WEBPACK FOOTER //
// ./src/components/Media/Media.jsx